(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .factory('ItensEstoqueService', ItensEstoqueServiceFactory);

  ItensEstoqueServiceFactory.$inject = [
    '$http',
    'RestService'
  ];

  // eslint-disable-next-line max-lines-per-function
  function ItensEstoqueServiceFactory($http, RestService) {
    //////////////////////////////////////////
    // Service data

    //////////////////////////////////////////
    // Service object declaration
    const service = {
      load,
      loadProducts,
      save,
      update,
      create,
      getItem,
      deleteItem,
      restoreItem,
      checkSaldoSementeBranca
    };
    return service;

    //////////////////////////////////////////
    // Function declarations

    function load({ complete = true, filters = {} }, page = 1) {
      const params = { complete };
      params.descricao = filters.descricao;
      params.possui_tratamento = filters.possuiTratamento;
      params.exibir = filters.exibir;

      if (filters.grupo && filters.grupo.id) {
        params.grupo_tipo = filters.grupo.id[0];
        params.grupo_codigo = filters.grupo.id[1];
      }
      if (page === null) {
        params.no_paginate = true;
      } else {
        params.page = page;
      }

      return RestService.getFromUrl(`${SERVER}v1/itens`, params);
    }

    function loadProducts() {
      return $http.get(`${SERVER}v1/itens/produtos`).then((response) => response.data);
    }

    function save(item) {
      if (item.id) {
        return update(item);
      }
      return create(item);
    }

    // TODO: complexity
    // eslint-disable-next-line complexity
    function update(item) {
      const itemEstoque = {
        descricao: item.descricao,
        cd_unidade: item.unidade.id,
        tp_produto: item.semente && item.produto ? item.produto.tipo_item : null,
        cd_produto: item.semente && item.produto ? item.produto.id[1] : null,
        cd_atividade: (item.atividade || {}).id || null,
        grupo: item.grupo.id[1],
        st_possui_tratamento: item.possui_tratamento ? 'S' : 'N',
        carencia_residual_dias: item.carencia_residual_dias
      };

      if (item.possui_tratamento && item.produto_origem) {
        itemEstoque.tipo_semente_origem = item.produto_origem.tipo_item;
        itemEstoque.codigo_semente_origem = item.produto_origem.item_id;
      }

      return $http.patch(`${SERVER}v1/itens/1/${item.id}`, { item_estoque: itemEstoque });
    }

    // TODO: complexity
    // eslint-disable-next-line complexity
    function create(item) {
      const itemEstoque = {
        descricao: item.descricao,
        cd_unidade: item.unidade.id,
        tp_produto: (item.produto && item.produto.tipo_item) || null,
        cd_produto: (item.produto && item.produto.id[1]) || null,
        cd_atividade: (item.atividade || {}).id || null,
        grupo: item.grupo.id[1],
        st_possui_tratamento: item.possui_tratamento ? 'S' : 'N',
        tipo: 1,
        carencia_residual_dias: item.carencia_residual_dias
      };

      if (item.possui_tratamento && item.produto_origem) {
        itemEstoque.tipo_semente_origem = item.produto_origem.tipo_item;
        itemEstoque.codigo_semente_origem = item.produto_origem.item_id;
      }

      return $http.post(`${SERVER}v1/itens`, { item_estoque: itemEstoque });
    }

    function getItem(item, complete = true) {
      if (item.id) {
        item = item.item_id;
      }

      return $http.get(`${SERVER}v1/itens/1/${item}?complete=${complete}`).then((response) => response.data);
    }

    function deleteItem(item) {
      if (item.id) {
        item = item.item_id;
      }

      return $http.delete(`${SERVER}v1/itens/1/${item}`);
    }

    function restoreItem(item) {
      if (item.id) {
        item = item.item_id;
      }

      return $http.patch(`${SERVER}v1/itens/1/${item}`, {
        item_estoque: { st_ativo: 'S' }
      });
    }

    function checkSaldoSementeBranca(produtos) {
      const produtosIds = produtos.flatMap((produto) => produto.item_id).join(',');
      return $http.get(`${SERVER}v1/itens/saldo_semente_branca?ids=${produtosIds}`).then((response) => response.data);
    }
  }
}());
